import { render, staticRenderFns } from "./ToolBarBaseItem.vue?vue&type=template&id=5c90ab40&scoped=true&lang=pug"
import script from "./ToolBarBaseItem.vue?vue&type=script&lang=js"
export * from "./ToolBarBaseItem.vue?vue&type=script&lang=js"
import style0 from "./ToolBarBaseItem.vue?vue&type=style&index=0&id=5c90ab40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c90ab40",
  null
  
)

export default component.exports